export const MapPinOutlineIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M7 1.167c-2.3 0-4.167 1.866-4.167 4.166C2.833 8.458 7 12.833 7 12.833s4.167-4.375 4.167-7.5c0-2.3-1.867-4.166-4.167-4.166Zm0 5.833a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
);
